import { useState } from 'react';
import type { PersonCount } from '@/pages/home/hooks/useWhatsApp';

interface ConversionSectionProps {
  onOpenWhatsApp: (personCount: PersonCount) => void;
}

export default function ConversionSection({ onOpenWhatsApp }: ConversionSectionProps) {
  const [selected, setSelected] = useState<PersonCount | null>(null);

  const options: { value: PersonCount; label: string }[] = [
    { value: '20-50', label: '20–50 Kişi' },
    { value: '50-100', label: '50–100 Kişi' },
    { value: '100-250', label: '100–250 Kişi' },
    { value: '250+', label: '250+ Kişi' },
    { value: 'unknown', label: 'Henüz Belli Değil' },
  ];

  return (
    <section id="teklif" className="py-16 md:py-24 bg-accent-950">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto text-center">
        <div className="reveal mb-4">
          <span className="inline-block px-3 py-1 bg-primary-500/10 border border-primary-500/20 rounded-full text-primary-400 font-label text-xs font-medium tracking-wide">
            TEKLİF AL
          </span>
        </div>
        <h2 className="reveal font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
          KAÇ KİŞİLİK YEMEK HİZMETİNE İHTİYACINIZ VAR?
        </h2>
        <p className="reveal text-background-300 font-body text-base md:text-lg max-w-2xl mx-auto mb-10">
          Birkaç kısa bilgi paylaşın, ihtiyacınıza uygun catering çözümünü
          belirleyelim.
        </p>

        <div className="reveal grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mb-10">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => setSelected(option.value)}
              className={`py-4 px-3 rounded-xl font-label text-sm font-semibold transition-all duration-300 border ${
                selected === option.value
                  ? 'bg-primary-500 text-foreground-950 border-primary-500'
                  : 'bg-accent-900/50 text-background-200 border-accent-800 hover:border-primary-400/50 hover:bg-accent-800/50'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => selected && onOpenWhatsApp(selected)}
          disabled={!selected}
          className={`reveal btn-primary text-base px-10 py-4 ${
            !selected ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          TEKLİFİMİ ÖĞREN
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
    </section>
  );
}